import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectIsAuthenticated, useAuthStore } from '@/stores/auth-store';
import { resolveAuthRedirect } from './auth-redirect';

/**
 * Guarda de las rutas públicas (login / registro).
 *
 * Si ya hay una sesión utilizable no tiene sentido pedir credenciales otra vez: se entra al
 * Panel, o a la ruta de origen que dejó `RequireAuth` (`location.state.from`). Es el espejo
 * de `RequireAuth`.
 *
 * `selectIsAuthenticated` comprueba el `exp` del JWT, así que un token vencido deja pasar al
 * formulario en vez de entrar con una sesión muerta (que terminaría en 401).
 */
export function RedirectIfAuthenticated() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to={resolveAuthRedirect(location.state)} replace />;
  }

  return <Outlet />;
}
